/* eslint-disable react/display-name */
// * You should NOT edit this file directly. Read CONTRIBUTING.md for more information on creating icons
import { __assign } from "tslib";
import React from 'react';
import { forwardRef } from '../../helpers/forwardRef';
import { BaseIcon } from '../../internal/BaseIcon';
export var MediaUiASkipBackIcon16Light = forwardRef('MediaUiASkipBackIcon16Light', function (props, ref) {
    return (React.createElement(BaseIcon, __assign({ ref: ref, viewBoxSize: 16 }, props),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M3 2.5a.5.5 0 0 1 1 0v5.147a.988.988 0 0 1 .402-.492l7.865-4.967A1.13 1.13 0 0 1 14 3.143v9.714c0 .89-.981 1.43-1.733.955L4.402 8.845A.988.988 0 0 1 4 8.353V13.5a.5.5 0 0 1-1 0v-11Zm10 .643a.13.13 0 0 0-.2-.11L4.937 8l7.865 4.967a.13.13 0 0 0 .199-.11V3.143Z" })));
});
